import { Component, h, primitiveNodeTypes, useRef } from "@lukekaalim/act";
import { html } from "@lukekaalim/act-web";

import * as three from 'three';
import { useJeffect } from "@kosmod/kit";
import { first } from "rxjs";
import { a3, ThreeJSRoot } from "@lukekaalim/act-three";

import { MiniModel } from "../../../defs";
import { Graphics3DSetup, ObjectClone, renderBeat, Snapshot } from "@kosmod/graphics-3d";
import { TheatreSceneResources } from "../../../hooks";


import classes from './Preview.module.css';

export type MiniModelPreviewProps = {
  miniModel: null | MiniModel,

  showBoundingBox?: boolean,

  graphics: Graphics3DSetup,
  resources: TheatreSceneResources,
};

export const MiniModelPreview: Component<MiniModelPreviewProps> = ({
  miniModel, resources,
  graphics, showBoundingBox
}) => {
  if (!miniModel)
    return null;

  const object = resources.miniModels.get(miniModel.id) || null;

  return h(Snapshot, { object, graphics, showBoundingBox });
};
